import { useEffect, useState } from 'react'
import gtm from '../../common/gtmTracker'
import { useAppSelector } from '../../common/hooks'
import { putMissionsSelected } from '../../services/missionApi'

import { StyledSelectedButton } from './styles/StyledSelectedButton.style'
import { getMissions } from '../../services/productApi'
import { PRICING_GROUP_IDS_IN_ACTIVE_DELIVERY_MISSION } from '../../common/constants'

interface SelectProps {
  missionId: number
  selected: boolean
  type: string
}

export const SelectMissionButton = ({ missionId, selected, type }: SelectProps) => {
  const { merchantCode, clubberEmail, websiteRegionId } = useAppSelector((state) => state.session)
  const [loading, setLoading] = useState(false)

  const isDeliveryMission = type === 'FREE_SHIPPING'
  const changeSeleted = isDeliveryMission ? true : !selected

  const setMissionSelected = async () => {
    setLoading(true)
    const errorResponse = await putMissionsSelected(missionId, changeSeleted)
    gtm.triggerSelectMission(merchantCode, missionId, !selected, clubberEmail)
    if (!errorResponse) {
      await getMissions(merchantCode)
    }
    setLoading(false)
  }

  const loadingText = loading ? '...' : ''
  const missionButtonText = selected ? 'Missão Ativa!' : 'Ativar Missão'

  useEffect(() => {
    if (
      !selected &&
      isDeliveryMission &&
      PRICING_GROUP_IDS_IN_ACTIVE_DELIVERY_MISSION.includes(websiteRegionId!)
    ) {
      setMissionSelected()
    }
  }, [])

  return (
    <StyledSelectedButton
      selected={selected}
      onClick={() => setMissionSelected()}
      disabled={loading}
    >
      {loadingText || missionButtonText}
    </StyledSelectedButton>
  )
}
